module.exports = __webpack_public_path__ + "static/media/total_accepted.696fcd30.svg";